import { SEM_BORDER_WIDTH_FORMS_ACTIVE, SEM_BORDER_WIDTH_FORMS_DEFAULT } from '../../tokens/border-width.generated.js';
import styled, { css } from 'styled-components';
import { StyledBox } from '../checkbox/index.styles.js';
import { getTypographyStyles } from '../../utils/index.js';
import { SEM_TYPOGRAPHY_FORMS_LABEL } from '../../tokens/typography.generated.js';
import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200 } from '../../tokens/spacing.generated.js';
import { FormMessage } from '../form-message/index.js';
import { SYS_SIZE_FIXED_25 } from '../../tokens/sizing.generated.js';
import { StyledRadioIndicator } from '../radio-button/index.styles.js';
export const StyledLabel = styled.label `
  cursor: pointer;
  display: flex;
  flex-direction: column;
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow;

  ${(props) => css `
    box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
      ${(props) => props.theme.cmp.color.forms.extendedSelection.surface.stroke.default};

    :has(input:checked:not(:disabled)),
    :has(input:hover:not(:disabled)),
    :has(input:active:not(:disabled)) {
      box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_ACTIVE}
        ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.default};
    }
  `}

  ${(props) => props.invalid &&
    css `
      box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
        ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.error};

      :has(input:checked:not(:disabled)),
      :has(input:hover:not(:disabled)),
      :has(input:active:not(:disabled)) {
        box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_ACTIVE}
          ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.error};
      }

      ${StyledBox} {
        border-color: ${props.theme.cmp.color.forms.extendedSelection.surface
        .stroke.error};
      }

      ${StyledInputContainer} {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.error};
      }

      ${StyledRadioIndicator} {
        border-color: ${props.theme.sem.color.forms.surface.control.stroke
        .error};
      }
    `}

    ${(props) => props.disabled &&
    css `
      cursor: not-allowed;
      box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_DEFAULT}
        ${props.theme.cmp.color.forms.extendedSelection.surface.stroke.disabled};

      :has(input:checked) {
        box-shadow: 0 0 0 ${SEM_BORDER_WIDTH_FORMS_ACTIVE}
          ${props.theme.cmp.color.forms.extendedSelection.surface.stroke
        .disabled};
      }

      ${StyledInputContainer} {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
      }

      ${StyledFormMessage} {
        color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
      }
    `}
`;
export const StyledFormMessage = styled(FormMessage) `
  margin-top: ${SYS_SPACE_FIXED_150};
`;
export const StyledImageLG = styled.img `
  aspect-ratio: 16/9;
  width: 100%;
`;
export const StyledInputContainer = styled.span `
  display: flex;
  column-gap: ${SYS_SPACE_FIXED_150};
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)};
`;
export const StyledInner = styled.span `
  display: block;
  padding: ${SYS_SPACE_FIXED_200};
`;
export const StyledToolbar = styled.span `
  display: flex;
  padding-top: ${SYS_SPACE_FIXED_200};
  // TODO: missing token
  border-top: ${SYS_SIZE_FIXED_25} solid rgba(217, 217, 217, 1);
  margin-top: ${SYS_SPACE_FIXED_200};
`;
export const StyledContent = styled.span `
  margin-top: ${SYS_SPACE_FIXED_200};
  display: flex;
`;
export const StyledImageSM = styled.img `
  width: 56px;
  aspect-ratio: 1/1;
`;
export const StyledInnerHeader = styled.span `
  display: flex;
  justify-content: space-between;
  gap: ${SYS_SPACE_FIXED_200};
  align-items: flex-start;
`;
//# sourceMappingURL=index.styles.js.map